module.exports = __webpack_public_path__ + "static/media/icon_macos.2b22f190.svg";